import type { PropType, ExtractPublicPropTypes } from 'vue'
import elTableProps from 'element-plus/es/components/table/src/table/defaults'
import { ElTable } from 'element-plus'
import { apiProps, type VisibleProps } from '@el-plus/utils/props'
import type { WithOnPrefixAndCamelCase } from '@el-plus/types'
import type {
  TableColumnCtx,
  PaginationProps,
  PaginationEmits,
} from 'element-plus'
import type { ButtonProps } from '@el-plus/components/buttons'
import { customColumnProps } from '@el-plus/components/custom-column'
const inheritTableProps = {
  ...elTableProps,
  // Table 的尺寸
  size: {
    ...elTableProps.size,
    default: 'default',
  },
  // 是否带有纵向边框
  border: {
    ...elTableProps.border,
    default: true,
  },
  // 表头样式
  headerCellStyle: {
    ...elTableProps.headerCellStyle,
    default: () => ({
      background: '#EEEFF3',
      // textAlign: 'center',
      fontSize: '14px',
      color: '#505050',
    }),
  },
}
export type TableColumn = Partial<
  TableColumnCtx & {
    required: boolean | (() => boolean)
    cellRequired: (scope: TableScope) => boolean
    headerRender: TableColumnCtx['renderHeader']
    disabled: boolean | ((scope: TableScope) => boolean)
    type: string
    props: Record<string, any> // eslint-disable-line @typescript-eslint/no-explicit-any
    filter: boolean // 是否显示筛选
    editable: boolean | ((formData: Record<string, any>) => void) // 是否可批量编辑
    [key: string]: any
  } & VisibleProps
>
export type TableScope<
  T extends Record<string, unknown> = Record<string, unknown>,
> = {
  column: TableColumnCtx<T>
  row: T
  $index: number
  store: unknown
  _self: unknown
}
const expandTableProps = {
  ...apiProps,
  columns: {
    type: Array as PropType<TableColumn[]>,
    default: () => [],
  },
  // 是否显示复选勾选列
  showSelectionCol: Boolean,
  // 是否显示单选勾选列
  showSingleSelectionCol: Boolean,
  // 是否显示序号列
  showIndexCol: {
    type: Boolean,
    default: true,
  },
  // 对齐方式
  align: {
    type: String as PropType<'left' | 'center' | 'right'>,
    default: 'center',
  },
  // 最小宽度
  minWidth: {
    type: [Number, String] as PropType<TableColumnCtx['minWidth']>,
  },
  // 操作列宽度
  actionColWidth: {
    type: [Number, String] as PropType<TableColumnCtx['width']>,
    default: 200,
  },
  // 序号列自定义
  indexFormatter: {
    type: [Number, Function] as PropType<TableColumnCtx['index']>,
  },
  disabled: Boolean,
  reserveSelection: Boolean,
  selectable: {
    type: Function as PropType<TableColumnCtx['selectable']>,
  },
  paginationProps: {
    type: Object as PropType<
      Partial<PaginationProps & WithOnPrefixAndCamelCase<PaginationEmits>>
    >,
    default: () => ({}),
  },
  showPagination: Boolean,
  isFrontPage: Boolean,
  // 操作列
  actionButtons: {
    type: Array as PropType<ButtonProps[]>,
    default: () => [],
  },
  // 格式化列
  formatColumns: {
    type: Array as PropType<TableColumn[]>,
    default: () => [],
  },
  // 是否初始化加载数据
  isInitSearch: {
    type: Boolean,
    default: true,
  },
  // 自定义列模块
  customColumnModule: {
    ...customColumnProps.module,
  },
  customColumnApi: {
    ...customColumnProps.api,
  },
  customColumnSaveApi: {
    ...customColumnProps.saveApi,
  },
}

export const tableProps = {
  ...inheritTableProps,
  ...expandTableProps,
} as const
export type TableProps = ExtractPublicPropTypes<typeof tableProps>
export const expandTablePropsKeys = Object.keys(expandTableProps)

export const tableEmits = [...ElTable.emits!, 'single-selection-change']
export type TableEmits = typeof tableEmits
export const tableEmitsKeys = tableEmits
